import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/framework/services/base.service';
import { APIUrl } from '../constants/APIUrls';

@Injectable({
  providedIn: 'root'
})
export class ConfigValuesService extends BaseService{

  constructor() {
    super();
  }
  getUIConfigValues(config:string):Observable<any>{
    let params: HttpParams = new HttpParams().set('config_name', config);
    let url = APIUrl.uiConfig;
    return this.httpService.getParams(url,params);
  }
  getIdleCheckValue(config: string): Observable<any> {
    let params: HttpParams = new HttpParams().set('config_name', config);
    let url = APIUrl.uiConfig;
    return this.httpService.getParams(url, params);
  }
}
